<template>
  <div>
    <!-- Display Loading if summary is undefined or empty -->
    <div v-if="!summary" class="loading-message">Loading...</div>

    <!-- Render the main content only if summary has data -->
    <div v-else class="stock-summary-card" :style="{ borderColor: platform.color }">
      <div class="summary-header" :style="{ color: platform.color }">
        <h3 class="platform-name mb-0">{{ platform.name }}</h3>
        <div class="current-price">
          {{ this.$helper.formatPrice(summary.platform_total, 0) }}
        </div>
      </div>

      <table class="stock-summary-table">
        <thead>
          <tr>
            <th></th> <!-- Empty header for alignment -->
            <th class="text-center">Stock Count</th>
            <th class="text-center">Amount</th>
            <th class="text-center">%</th>
          </tr>
        </thead>
        <tbody>
          <!-- Changes Row -->
          <tr :class="{'positive-status': summary.up_down > 0, 'negative-status': summary.up_down < 0}">
            <td><strong>Changes:</strong></td>
            <td class="text-center">{{ summary.stock_count }}</td>
            <td class="text-center">
              {{ this.$helper.formatPrice(summary.up_down, 0) }}
            </td>
            <td class="text-center">{{ (summary.up_down_percent).toFixed(2) }}%</td>
          </tr>

          <!-- Up Row -->
          <tr>
            <td><strong>Up:</strong></td>
            <td class="text-center">
              {{ summary.total_stock_up }}
            </td>
            <td class="text-center">
              {{ this.$helper.formatPrice(summary.amount_up, 0) }}
            </td>
            <td class="text-center">{{ summary.percent_up.toFixed(2) }}%</td>
          </tr>

          <!-- Down Row -->
          <tr>
            <td><strong>Down:</strong></td>
            <td class="text-center">
              {{ summary.total_stock_down }}
            </td>
            <td class="text-center">
              {{ this.$helper.formatPrice(summary.amount_down, 0) }}
            </td>
            <td class="text-center">{{ this.$helper.formatPercentage(summary.percent_down / 100) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    summary: Object,
    platforms: Array,
  },
  computed: {
    platform() {
      const matchedPlatform = this.platforms.find(
        (p) => p.platform_id == this.summary?.platform_id
      );
      return matchedPlatform || {
        name: "Overall Total",
        color: "#000", // Default color for overall totals
      };
    },
  },
};
</script>